/**
 * Enum para el estado de "Ya tienes una póliza activa"
 * Cada estado tiene un código numérico asociado
 */
export enum YaTienesPolizaEstado {
  /** Ya tienes una póliza activa */
  YA_TIENES_POLIZA_ACTIVA = 64
}

/**
 * Mapeo de códigos a descripciones legibles
 */
export const YaTienesPolizaDescripciones: Record<YaTienesPolizaEstado, string> = {
  [YaTienesPolizaEstado.YA_TIENES_POLIZA_ACTIVA]: 'Ya tienes una póliza activa'
};
